import { Button, Flex } from "antd";

type ActionButtonsProps = {
  onCancel: () => void;
  onUpdate: () => void;
  isLoading?: boolean;
};

export default function ActionButtons({
  onCancel,
  onUpdate,
  isLoading = false,
}: ActionButtonsProps) {
  return (
    <Flex align="center" wrap gap={20}>
      <Button
        variant="outlined"
        type="primary"
        size="middle"
        className="h-12 rounded-lg !bg-theme-red-50 !text-theme-red-500"
        onClick={onCancel}
        disabled={isLoading}
      >
        বাতিল করুন
      </Button>
      <Button
        type="primary"
        size="middle"
        className="h-12 rounded-lg"
        onClick={onUpdate}
        loading={isLoading}
      >
        আপডেট করুন
      </Button>
    </Flex>
  );
}
